module.exports = __webpack_public_path__ + "static/media/hakusteel-2.5762ca74.png";